<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('feeExpirationAlert.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('feeExpirationAlert.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
          <a-drawer
            :title="$t('invoice.filter')"
            placement="right"
            :closable="false"
            :visible="visible"
            @close="() => (visible = false)"
            :zIndex="1020"
            width="300px"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </div>
          </a-drawer>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td
              v-if="record.student_rowspan"
              :rowspan="record.student_rowspan"
              class="ts-whitespace-no-wrap align-middle"
            >
              {{ record.branch_name }}
            </td>
            <td
              v-if="record.student_rowspan"
              :rowspan="record.student_rowspan"
              class="ts-whitespace-no-wrap align-middle"
            >
              {{ record.card_number }}
            </td>
            <td
              v-if="record.student_rowspan"
              :rowspan="record.student_rowspan"
              class="ts-whitespace-no-wrap align-middle"
            >
              {{ record.student_name }}
            </td>
            <td
              v-if="record.student_rowspan"
              :rowspan="record.student_rowspan"
              class="ts-whitespace-no-wrap text-center align-middle"
            >
              {{ record.gender }}
            </td>
            <td
              v-if="record.student_rowspan"
              :rowspan="record.student_rowspan"
              class="ts-whitespace-no-wrap align-middle"
            >
              {{ record.phone }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.grade }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.fee_type }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.fee_name }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.fee_start_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.fee_expiration_date }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span :class="daysUntilExpiryClass(record.days_until_expiry)">
                <i :class="daysUntilExpiryIcon(record.days_until_expiry)"></i>
                {{ daysUntilExpiryText(record.days_until_expiry) }}
              </span>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'feeExpirationAlert',
  data() {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('feeExpirationAlert', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.feeExpirationAlert.search
      },
      set(newVal) {
        this.$store.commit('feeExpirationAlert/SET_SEARCH', newVal)
        this.$store.commit('feeExpirationAlert/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.feeExpirationAlert.branch_id
      },
      set(newValue) {
        this.$store.commit('feeExpirationAlert/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('feeExpirationAlert.branchName') },
        { name: this.$t('feeExpirationAlert.cardNumber') },
        { name: this.$t('feeExpirationAlert.studentName') },
        {
          name: this.$t('feeExpirationAlert.gender'),
          style: 'text-align:center'
        },
        { name: this.$t('feeExpirationAlert.phone') },
        { name: this.$t('feeExpirationAlert.grade') },
        { name: this.$t('feeExpirationAlert.feeType') },
        { name: this.$t('feeExpirationAlert.feeName') },
        {
          name: this.$t('feeExpirationAlert.feeStartDate'),
          style: 'width: 150px'
        },
        {
          name: this.$t('feeExpirationAlert.feeExpirationDate'),
          style: 'width: 180px'
        },
        {
          name: this.$t('feeExpirationAlert.daysUntilExpiry'),
          style: 'width: 150px; text-align:center'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'feeExpirationAlert/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    daysUntilExpiryText(days) {
      if (days === null || days === undefined) {
        return ''
      }

      if (days < 0) {
        return `${Math.abs(days)} day ago`
      }

      if (days === 0) {
        return 'Today'
      }

      return `${days} day left`
    },
    daysUntilExpiryClass(days) {
      if (days === null || days === undefined) {
        return ''
      }

      if (days < 0) {
        return 'expiry-pill expiry-pill-overdue'
      }

      if (days === 0) {
        return 'expiry-pill expiry-pill-today'
      }

      if (days <= 3) {
        return 'expiry-pill expiry-pill-soon'
      }

      return 'expiry-pill expiry-pill-normal'
    },
    daysUntilExpiryIcon(days) {
      if (days === null || days === undefined) {
        return ''
      }

      if (days < 0) {
        return 'fa fa-exclamation-circle mr-1'
      }

      if (days === 0) {
        return 'fa fa-clock mr-1'
      }

      return 'fa fa-calendar-check mr-1'
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('feeExpirationAlert/RESET_STATE')
    next()
  }
}
</script>

<style scoped>
.expiry-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  padding: 4px 9px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 12px;
  border: 1px solid transparent;
}

.expiry-pill-overdue {
  color: #b91c1c;
  background: #fee2e2;
  border-color: #fecaca;
}

.expiry-pill-today {
  color: #92400e;
  background: #fef3c7;
  border-color: #fde68a;
}

.expiry-pill-soon {
  color: #9a3412;
  background: #ffedd5;
  border-color: #fed7aa;
}

.expiry-pill-normal {
  color: #166534;
  background: #dcfce7;
  border-color: #bbf7d0;
}
</style>
